import React from "react";

/**
 * LoadingButton
 * - Zonder eigen variantklasse: bestaande .btn styles (en dark mode varianten)
 * - Met een variantklasse in className (btn-primary-green, btn-outline-green, ...): enkel die
 *   variant, géén .btn erbij (geen dubbele stijl)
 * - Variant "ghost" ondersteund via prop (alleen i.c.m. .btn)
 * - Spinner gebruikt currentColor voor automatische contrast in light/dark
 */
export default function LoadingButton({
  loading,
  children,
  disabled,
  spinnerPosition = "left",
  variant = "primary", // "primary" | "ghost"
  className = "",
  ...props
}) {
  const isDisabled = disabled || loading;

  const spinner = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 50 50"
      aria-hidden="true"
      role="img"
      focusable="false"
      className="btn-spinner"
      style={{ display: "inline-block" }}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        opacity="0.25"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        d="M25 5 a 20 20 0 0 1 0 40"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.9s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );

  // `.btn` alleen als de aanroeper geen eigen knopvariant meegeeft (btn-primary-green,
  // btn-outline-green, btn-danger-outline, ...). Anders stapelen twee knopstijlen: .btn legt
  // zijn schaduw, focus-ring, disabled-opacity en :active-verschuiving over de variant heen.
  // `.loading-btn` zorgt in beide gevallen voor spinner + tekst naast elkaar.
  const hasVariantClass = /(^|\s)btn-[a-z]/.test(className);
  const classes = [
    "loading-btn",
    hasVariantClass ? "" : "btn",
    !hasVariantClass && variant === "ghost" ? "ghost" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      {...props}
      disabled={isDisabled}
      className={classes}
      aria-busy={loading || undefined}
    >
      {loading && spinnerPosition === "left" && spinner}
      <span>{children}</span>
      {loading && spinnerPosition === "right" && spinner}
    </button>
  );
}
